import React from 'react';
import { Link } from 'react-router-dom';
import { trackPhoneClick, ClickLocation } from '../../email/utils/trackingUtils';
import '../style/mobile-cta.css';

interface MobileCtaProps {
    /** Full tel number, e.g. "+351219349560" */
    phone: string;
    /** Human-readable number, e.g. "219 349 560" */
    phoneDisplay: string;
    /** Where the quote button points, e.g. "/orcamento?service=pneus" */
    quoteHref: string;
    /** Tracking source label */
    source: ClickLocation;
    /** Portuguese language flag */
    pt: boolean;
}

/**
 * Inline call-to-action shown directly under the page intro on mobile:
 * a full-width quote button, a full-width call button with the number,
 * and the legally required national call-cost note.
 */
export const MobileInlineCta: React.FC<MobileCtaProps> = ({ phone, phoneDisplay, quoteHref, source, pt }) => (
    <div className="m-cta">
        <Link to={quoteHref} className="m-cta__btn m-cta__btn--quote">
            <i className="fas fa-file-lines"></i>
            <span>{pt ? 'Peça orçamento' : 'Request a quote'}</span>
            <i className="fas fa-chevron-right m-cta__chevron"></i>
        </Link>
        <a
            href={`tel:${phone}`}
            className="m-cta__btn m-cta__btn--call"
            onClick={() => trackPhoneClick(source)}
        >
            <i className="fas fa-phone"></i>
            <span>{pt ? 'Ligar' : 'Call'} {phoneDisplay}</span>
            <i className="fas fa-chevron-right m-cta__chevron"></i>
        </a>
        <p className="m-cta__note">{pt ? 'Chamada para a rede fixa nacional' : 'Call to national landline network'}</p>
    </div>
);

/**
 * Fixed call-to-action bar pinned to the bottom of the viewport on mobile.
 */
export const MobileCtaBar: React.FC<MobileCtaProps> = ({ phone, quoteHref, source, pt }) => (
    <div className="m-bar">
        <a
            href={`tel:${phone}`}
            className="m-bar__btn m-bar__btn--call"
            onClick={() => trackPhoneClick(source)}
        >
            <i className="fas fa-phone"></i>
            <span>{pt ? 'Ligar' : 'Call'}</span>
        </a>
        <Link to={quoteHref} className="m-bar__btn m-bar__btn--quote">
            <i className="fas fa-file-lines"></i>
            <span>{pt ? 'Orçamento' : 'Quote'}</span>
        </Link>
    </div>
);
